module.exports = __webpack_public_path__ + "img/icon_more.e3abb8e2.svg";